module.exports = __webpack_public_path__ + "media/icons/icon_breathe-0a81bab7.svg";